import FinancialsTemplateFieldsFragment from "components/financials/modern/graphql/fragments/FinancialsTemplateFieldsFragment";
import IndicatorFieldsFragment from "components/financials/modern/graphql/fragments/IndicatorFieldsFragment";
import gql from "graphql-tag";

export default gql`
  mutation AddFinancialsTemplate($input: FinancialsTemplateInput!) {
    addFinancialsTemplate(input: $input) {
      ...FinancialsTemplateFields
      indicators {
        ...IndicatorFields
      }
    }
  }

  ${IndicatorFieldsFragment}
  ${FinancialsTemplateFieldsFragment}
`;
